// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixLocation from 'wix-location';
$w.onReady( function() {
wixLocation.to("https://www.dropbox.com/s/30417iy11znt1m3/vcard-4.vcf?dl=0raw=1");
}) ;